import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/tmp/gatsby/src/components/layout.js";
import SEO from '../components/seo.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Datenschutzerklärung" slug="datenschutzerklaerung/" mdxType="SEO" />
    <h1>{`Datenschutzerklärung`}</h1>
    <p>{`Wir legen großen Wert auf den Schutz Ihrer Daten. Um Sie in vollem Umfang über die Verwendung personenbezogener Daten zu informieren, bitten wir Sie die folgenden Datenschutzhinweise zur Kenntnis zu nehmen.`}</p>
    <h3>{`Persönliche Daten`}</h3>
    <p>{`Persönliche Daten, die Sie auf dieser Website elektronisch übermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder andere persönlichen Angaben, werden von uns nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht ohne Zustimmung an Dritte weitergegeben. Der Provider erhebt und speichert automatisch Informationen am Webserver wie verwendeter Browser, Betriebssystem, Verweisseite, IP-Adresse, Uhrzeit des Zugriffs usw. Diese Daten können ohne Prüfung weiterer Datenquellen keinen bestimmten Personen zugeordnet werden und wir werten diese Daten auch nicht weiter aus solange keine rechtswidrige Nutzung unserer Webseite vorliegt.`}</p>
    <h3>{`Cookies & Tracking`}</h3>
    <p>{`Dies Website verwendet KEINE Cookie oder andere Speicher zur Identifikation und Aufzeichnung von Nutzerverhalten.`}</p>
    <p>{`Sie können das Tracking in ihrem Browser über die `}<inlineCode parentName="p">{`Do Not Track (DNT)`}</inlineCode>{` Option jederzeit deaktivieren.`}</p>
    <h3>{`Google Analytics`}</h3>
    <p>{`Unsere Website nutzt Funktionen des Webanalysedienstes Google Analytics, der von Google LLC, 1600 Amphitheatre Parkway Mountain View, CA 94043, USA (“Google”) angeboten wird. `}</p>
    <p><strong parentName="p">{`Die Option zur Identifikation per Cookie ist deaktiviert.`}</strong></p>
    <p>{`Die Informationen über Ihre Nutzung dieser Website (einschließlich Ihrer IP-Adresse und die URLs der aufgerufenen Webseiten sowie der Attribute der Webseite) werden an Server von Google in den USA übertragen und dort gespeichert.`}</p>
    <p>{`Die dabei gewonnenen Daten werden genutzt, um die Nutzung der Website zu optimieren.`}</p>
    <p>{`Unsere Website verwendet die von Google Analytics gebotene Möglichkeit der IP-Anonymisierung. Ihre IP-Adresse wird daher von Google gekürzt/anonymisiert, sobald Google Ihre IP-Adresse erhält. In unserem Auftrag wird Google diese Informationen verwenden, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen an uns zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird von Google nicht mit anderen Daten zusammengeführt.`}</p>
    <p>{`» Nähere Informationen zu den `}<a parentName="p" {...{
        "href": "https://www.google.com/analytics/terms/de.html"
      }}>{`Nutzungsbedingungen von Google`}</a>{` sowie `}<a parentName="p" {...{
        "href": "https://www.google.at/intl/at/policies/"
      }}>{`Googles Datenschutzerklärung`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      